import { createFileRoute } from '@tanstack/react-router';
import { Page } from '../app/Page.tsx';
import { ReleaseNotesList } from '../features/whats-new/ReleaseNotesList.tsx';
import { formatDate } from '../lib/format.ts';
import { hasReleaseNotes, releaseNotes } from '../lib/whats-new.ts';
import { m } from '../paraglide/messages.js';

export const Route = createFileRoute('/settings_/whats-new')({ component: WhatsNewScreen });

/** Settings → What's new: the notes of the installed version, any time. */
function WhatsNewScreen() {
  return (
    <Page title={m.whats_new_page()} nav="inline" back={{ to: '/settings' }}>
      {hasReleaseNotes ? (
        <>
          <p>
            {m.whats_new_version({ version: releaseNotes.version })}
            {releaseNotes.date && ` · ${formatDate(releaseNotes.date)}`}
          </p>
          <ReleaseNotesList notes={releaseNotes} />
        </>
      ) : (
        <p>{m.whats_new_empty()}</p>
      )}
    </Page>
  );
}
